import React, { useEffect, useState, useContext } from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Offcanvas, Form, Button, Nav, Navbar, NavDropdown, Carousel, Modal } from "react-bootstrap";

import { auth, firebase, firestore } from "../Database/firebase";

import { Row, Col, Card, Tabs, Tab } from 'react-bootstrap'

import { BrowserRouter, Routes, Route, NavLink, useParams, useNavigate, Link } from "react-router-dom";

import { AuthContext } from "../Authentication/AuthProvider";

import MaintenancePage from "./MaintenancePage";
import "./Header.css";

import { BsSearch } from "react-icons/bs";
import Error from "./Error";
import HomeView from "./HomeDefault";
import Footer from "./Footer";
import SearchBook from "../component_search/SearchBook";
import ProductView from "../Purchase/ProductView";
import LogIn from "../Authentication/LogIn";
import SignUp from "../Authentication/SignUp";
import ActivateCouponCodeios from "../Purchase/ActivateCouponCode_ios";
import Account from "../component_profile/Account";
import UserData from "../component_profile/Admin/UserData/UserData";
import ManageProduct from "../component_profile/Admin/ManageProduct/ManageProduct";
// import CouponCode from "../component_profile/Admin/CouponCode/CouponCode";
import ManageProductDetail from "../component_profile/Admin/ManageProduct/ManageProductDetail";
import ResetPassword from "../Authentication/ResetPassword";
import TermsOfService from "./aboutus/TermsOfService";
import Category from "./content/category/Category";
import SubCategory from "./content/category/SubCategory";
import TypeCategory from "./content/category/TypeCategory";
import MyBook from "../component_profile/User/MyBook/MyBook";
import PurchaseHistory from "../component_profile/User/PurchaseHistory/PurchaseHistory";
import MyProduct from "../component_profile/Merchant/MyProduct/MyProduct";
import MerchantIncomeios from "../component_profile/Merchant/MerchantIncome/MerchantIncomeios";
import Contact from "./aboutus/Contact";
import AboutUs from "./aboutus/AboutUs";
import HowToRead from "./howto/HowToRead";
import HowToPurchase from "./howto/HowToPurchase";
import MerchantIncomeWebios from "../component_profile/Merchant/MerchantIncome/MerchabtIncomeWebios";
import Profile from "../component_profile/User/Profile/Profile";
import DownloadApp from "./download/DownloadApp";
import MerchantIncomePerBookios from "../component_profile/Merchant/MerchantIncome/MerchantIncomePerBookios";
import MerchantIncomePerBookWebios from "../component_profile/Merchant/MerchantIncome/MerchabtIncomePerBookWebios";

import EduLaw_long_icon from "../component_home/asset/EduLaw_long_icon.png"

import MerchantNameCategory from "./content/category/MerchantNameCategory";



function Header() {

    const [maintenanceMode, setMaintenanceMode] = useState(false);
    useEffect(() => {
  const unsub = firestore
    .collection("system")
    .doc("settings")
    .onSnapshot((snap) => {
      console.log("maintenance snap exists:", snap.exists);
      console.log("maintenance data:", snap.data());

      setMaintenanceMode(snap.data()?.maintenanceMode === true);
    }, (err) => {
      console.log("maintenance error:", err);
    });

  return () => unsub();
}, []);

    let activeHeaderButtonClassName = "nav-active";
    let nonActiveHeaderButtonClassName = "nav-nonaction"

    

   


    const [showMyArticleNotlogin, setShowMyArticleNotlogin] = useState(false);
    const handleCloseMyArticleNotlogin = () => setShowMyArticleNotlogin(false);



    const [currentUser, setCurrentUser] = useState(null);
    const authContext = useContext(AuthContext);

    //const [displayName, setDisplayName] = useState("");

    
    var user = auth.currentUser;
    var email, uid;

    if (user != null) {
        
        email = user.email;
        uid = user.uid;  
        console.log(uid);
        console.log(user.displayName);

    }

    const signOutHandler = () => {
        auth.signOut()
            .then(() => {
                console.log("LogOut OK");
            })
            .catch((err) => {
                console.log("LogOut Not OK" + err)
            });
    }

    if (maintenanceMode) {
        return <MaintenancePage />;
    }


  return (

    <div>

        <Navbar expand="lg" className="mb-3">
            <Container bor>

                <Navbar.Brand href="/">
                    <img
                        src={EduLaw_long_icon}
                        width="160"
                        height="55"
                        className="d-inline-block align-top"
                        alt=""
                    />
                    {/* <h1 style={{fontWeight: 'bold'}}>EduLaw</h1> */}
                </Navbar.Brand>

                    <Navbar.Toggle expand="lg" />

                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-lg`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                        placement="end"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`} style={{fontFamily: 'Kanit'}}>
                            EduLaw.com
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            
                            <Nav className="me-auto" style={{marginTop: 6}}>

                            <NavLink onClick={() => {window.location.href="/"}} style={{ color: "black", marginRight: 8, marginTop: 8, textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>หน้าหลัก</strong></NavLink>

                                <NavLink onClick={() => {window.location.href='/Category/แพ่ง'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>แพ่ง</strong></NavLink>
                                <NavLink onClick={() => {window.location.href='/Category/อาญา'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>อาญา</strong></NavLink>
                                <NavLink onClick={() => {window.location.href='/Category/วิแพ่ง'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>วิแพ่ง</strong></NavLink>
                                <NavLink onClick={() => {window.location.href='/Category/วิอาญา'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>วิอาญา</strong></NavLink>
                                {/* <NavLink onClick={() => {window.location.href='/BookArticleCategory'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>หนังสือทั้งหมด</strong></NavLink> */}
                                
                                <NavLink onClick={() => {window.location.href='/SearchBook'}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit', fontWeight: 'bold' }}><strong>ค้นหาหนังสือ</strong></NavLink>


                                <NavDropdown title="เกี่ยวกับเรา" id="collapsible-nav-dropdown" style={{color: "black", textDecoration: 'none', fontFamily: 'Kanit'}}>
                                        <NavDropdown.Item onClick={() => {window.location.href="/AboutUs"}}>เกียวกับ EduLaw</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => {window.location.href="/HowToPurchase"}}>การซื้อหนังสือ</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => {window.location.href="/HowToRead"}}>วิธีอ่านหนังสือ</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => {window.location.href="/TermsOfService"}}>ข้อกำหนดการให้บริการ</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => {window.location.href="/DownloadApp"}}>ดาวน์โหลด EduLaw</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item onClick={() => {window.location.href="/Contact"}}>ติดต่อเรา</NavDropdown.Item>
                                </NavDropdown>

                               
                            </Nav>




                            <Nav className="justify-content-end flex-grow-1">



                                {user ? (
                                    <>
                                        <Nav.Link onClick={() => {window.location.href="/MyBook"}} style={{marginTop: 8, marginRight: 8, color: "black", fontFamily: 'Kanit'}} ><strong>หนังสือของฉัน</strong></Nav.Link>
                                        {/* <NavLink onClick={() => {window.location.href="/Account"}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button variant="warning"><strong>{displayName}</strong></Button></NavLink>&nbsp;&nbsp; */}
                                        <NavLink onClick={() => {window.location.href="/Account"}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button variant="warning"><strong>{email}</strong></Button></NavLink>&nbsp;&nbsp;
                                        
                                        {/* Test LogOut */}
                                        {/* <NavLink onClick={() => signOutHandler()} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button variant="warning"><strong>Log Out</strong></Button></NavLink>&nbsp;&nbsp; */}
                                    </>
                                ) : (
                                    <>
                                        {/* <Nav.Link onClick={() => {window.location.href="/ActivateCouponCodeios"}} style={{marginTop: 8, marginRight: 8, color: "black", fontFamily: 'Kanit'}} ><strong>Coupon Code</strong></Nav.Link>
                                        <Nav.Link onClick={() => setShowMyArticleNotlogin(true)} style={{marginTop: 8, marginRight: 8, color: "black", fontFamily: 'Kanit'}} ><strong>หนังสือของฉัน</strong></Nav.Link> */}
                                        <NavLink onClick={() => {window.location.href="/LogIn"}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button className="rounded-0" variant="outline-secondary" style={{color: "black"}}><strong>เข้าสู่ระบบ</strong></Button></NavLink>
                                        <NavLink onClick={() => {window.location.href="/SignUp"}} style={{ marginTop: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button className="rounded-0" variant="dark"><strong>สมัครใหม่</strong></Button></NavLink>
                                    </>
                                )}

                              
                                
                                    
                               
                            </Nav>




                            {/* <Nav className="justify-content-end flex-grow-1">

                              
                                {user ? (
                                    <>
                                    
                                    <Nav.Link onClick={() => {window.location.href="/MyArticle/" + uid}} style={{marginTop: 8, marginRight: 8, color: "black", fontFamily: 'Kanit'}} ><strong>บทความของฉัน</strong></Nav.Link>
                                    <NavLink onClick={() => {window.location.href="/User/Profile"}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button variant="warning"><strong>{email}</strong></Button></NavLink>&nbsp;&nbsp;
                                    
                                    </>
                                ) : (
                                    <>
                                    <Nav.Link onClick={() => setShowMyArticleNotlogin(true)} style={{marginTop: 8, marginRight: 8, color: "black", fontFamily: 'Kanit'}} ><strong>บทความของฉัน</strong></Nav.Link>
                                    <NavLink onClick={() => {window.location.href="/LogIn"}} style={{ marginTop: 8, marginRight: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button className="rounded-0" variant="outline-secondary" style={{color: "black"}}><strong>เข้าสู่ระบบ</strong></Button></NavLink>
                                    <NavLink onClick={() => {window.location.href="/SignUp"}} style={{ marginTop: 8, color: "black", textDecoration: 'none', fontFamily: 'Kanit' }}><Button className="rounded-0" variant="dark"><strong>สมัครใหม่</strong></Button></NavLink>
                                    </>
                                )}
                            </Nav> */}

                        </Offcanvas.Body>

                    </Navbar.Offcanvas>
            </Container>
        </Navbar>


                                    <Modal 
                                        show={showMyArticleNotlogin} 
                                        onHide={handleCloseMyArticleNotlogin} 
                                        animation={false} 
                                        size="sm"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>

                                        <Modal.Header>
                                            <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
                                        </Modal.Header>
                                          
                                        <Modal.Body>
                                            <Link onClick={() => (window.location.href="/LogIn", setShowMyArticleNotlogin(false))} style={{textDecoration: 'none'}}>เข้าสู่ระบบ</Link> หรือ <Link onClick={() => (window.location.href="/SignUp", setShowMyArticleNotlogin(false))} style={{textDecoration: 'none'}}>สมัครสมาชิก</Link> เพื่อเข้าใช้งาน
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleCloseMyArticleNotlogin}>
                                                ปิด
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
             
                

                <Routes>
                
                    <Route path='/' element={<HomeView/>} />
               
                    <Route path='/SearchBook' element={<SearchBook/>} />

                    {/* Authentication */}
                    {/* <Route path='/LogIn' element={<LogIn/>} />
                    <Route path='/SignUp' element={<SignUp/>} />
                    <Route path='/ResetPassword' element={<ResetPassword/>} /> */}


                    {/* PRODUCT */}
                  {/*   <Route path='/ProductView'>
                        <Route path=":productId" element={<ProductView/>} />
                    </Route> */}

                    {/* Category - Sub - Type */}
                    <Route path='/Category'>
                        <Route path=":categoryName" element={<Category/>} />
                    </Route>

                    <Route path='/SubCategory'>
                        <Route path=":subcategoryName" element={<SubCategory/>} />
                    </Route>

                    <Route path='/TypeCategory'>
                        <Route path=":typecategoryName" element={<TypeCategory/>} />
                    </Route>

                    <Route path='/MerchantNameCategory'>
                        <Route path=":merchantID" element={<MerchantNameCategory/>} />
                    </Route>

                    {/* Activate Coupon Code */}
                    <Route path='/ActivateCouponCodeios' element={<ActivateCouponCodeios/>} />

                    {/* Account */}
                    {/* <Route path='/Account' element={<Account/>} /> */}
                    {/* Account - Admin */}
                    {/* <Route path='/UserData' element={<UserData/>} /> */}
                    <Route path='/ManageProduct' element={<ManageProduct/>} />
                    <Route path='/ManageProductDetail'>
                        <Route path=":productId" element={<ManageProductDetail/>} />
                    </Route>
                    {/* <Route path='/CouponCode' element={<CouponCode/>} /> */}

                    {/* Account - Merchant */}
                    <Route path='/MerchantIncomePerBookWebios' element={<MerchantIncomePerBookWebios/>} />
                    <Route path='/MerchantIncomePerBookios' element={<MerchantIncomePerBookios/>} />
                    <Route path='/MerchantIncomeWebios' element={<MerchantIncomeWebios/>} />
                    <Route path='/MerchantIncomeios' element={<MerchantIncomeios/>} />
                    <Route path='/MyProduct' element={<MyProduct/>} />

                    {/* Account - User */}
                    <Route path='/Profile' element={<Profile/>} />
                    <Route path='/MyBook' element={<MyBook/>} />
                    <Route path='/PurchaseHistory' element={<PurchaseHistory/>} />

                    {/* Service-Data Footer-Data */}
                    <Route path='/TermsOfService' element={<TermsOfService/>} />
                    <Route path='/Contact' element={<Contact/>} />
                    <Route path='/AboutUs' element={<AboutUs/>} />
                    <Route path='/HowToRead' element={<HowToRead/>} />
                    <Route path='/HowToPurchase' element={<HowToPurchase/>} />
                    <Route path='/DownloadApp' element={<DownloadApp/>} />
                    


                    <Route path='*' element={<Error/>} />



                   
                </Routes>

                 

    

    </div>

    

    );
}

export default Header;